import React, { ReactElement, ReactNode, useState } from "react";
import classnames from "classnames";

import { useIsMounted } from "@sportal/cdk/hooks/useIsMounted";
import { FormContext, ProgressStage } from "../formContext";

interface FormProps {
  onSubmit: () => Promise<any>;
  name: string;
  description: ReactElement | string;
  hiddenDescription?: boolean;
  children: ReactNode;
}

export const Form = ({
  onSubmit,
  name,
  description,
  hiddenDescription,
  children,
}: FormProps) => {
  const [progressStage, setProgressStage] = useState<ProgressStage>(
    ProgressStage.Default
  );

  const checkIsMounted = useIsMounted();

  const setDefaultStage = () => {
    const setDefault = setTimeout(() => {
      if (checkIsMounted()) {
        setProgressStage(ProgressStage.Default);
      }
    }, 1500);

    return () => {
      clearTimeout(setDefault);
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (progressStage !== ProgressStage.Default) return;

    setProgressStage(ProgressStage.Processing);

    try {
      await onSubmit();
      setProgressStage(ProgressStage.Success);
    } catch (e) {
      setProgressStage(ProgressStage.Error);
    }

    setDefaultStage();
  };

  return (
    <FormContext.Provider value={{ progressStage }}>
      <form onSubmit={handleSubmit} aria-labelledby={name}>
        <fieldset>
          <legend
            className={classnames("form-description", {
              "sr-only": hiddenDescription,
            })}
            id={name}
          >
            {description}
          </legend>

          {children}
        </fieldset>
      </form>
    </FormContext.Provider>
  );
};
